import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi'; // Use correct path: ../../../api/risapi
import { risapi } from './risapi'; // Use correct path: ../../../api/risapi

export const getRates = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/rates', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchRate = async (rateId, callback) => {
    try {
        const response = await risapi.get(`/api/rates/${rateId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createRate = async (newRate, callback) => {
    try {
        const response = await risapi.post('/api/rates', newRate, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation
    }
};

export const updateRate = async (editRate, callback) => {
    try {
        const response = await risapi.put(`/api/rates/${editRate.id}`, editRate, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation
    }
};

export const destroyRate = async (deleteRate, callback) => {
    try {
        const response = await risapi.delete(`/api/rates/${deleteRate.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ rate: deleteRate }); // Success
        }
    } catch (error) {
        callback({ error }); // Let list page handle conflict/error
    }
};

export const destroyRatesMultiple = async (ids, callback) => {
    try {
        const sendData = { ids: ids, _method: 'delete' };
        const response = await risapi.post('/api/rates/delete/multiple', sendData, getAxiosConfig());
        if (response.status === 204) {
            callback({ rate: ids }); // Success
        }
    } catch (error) {
        callback({ error }); // Let list page handle conflict/error
    }
};


/**
 * Fetches the applicable rate, price, and adjustments for a product combination.
 * @param {object} params - { product_id, uom_id, rate_type_id, invoice_date }
 * @param {function} callback - Function to call with response data or error
 */
export const findRatePrice = async (params, callback) => {
    try {
        // Pass params as URL query string
        const response = await risapi.get(getAPIFullUrl('/api/rates/data/find-price', params), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Returns { rate: {...} }
        }
    } catch (error) {
        // Don't use global handleApiError, let form show inline error
        console.error("API Error in findRatePrice:", error);
        callback({ error }); // Pass error back to the form
    }
};